<template>
  <div class="chart-container table">
    <h1>{{name}}</h1>
    <Table
      class="chart"
      :head="this.formattedHead"
      :body="this.formattedBody"
    />
  </div>
</template>

<script>

import Table from "../generics/Table";

function formatHead(columns){
  const formatted = []
  for(const c of columns){
    c.html = c.name
    formatted.push(c)
  }
  return formatted
}

function formatBody(body){
  if(!body){
    return []
  }
  const formatted  = []
  for(const row of body){
    const formattedRow = {
      editing_disabled: true,
      data: []
    }
    for(const cell of row){
      formattedRow.data.push({html: cell})
    }
    formatted.push(formattedRow)
  }
  return formatted
}

export default {
  name: 'DataTable',
  data () {
    return {
      formattedHead: formatHead(this.columns),
      formattedBody: this.body ? formatBody(this.body) : []
    }
  },
  props: ['body','columns','name'],
  watch: {
    columns: function(newCols) {
      this.formattedHead = formatHead(newCols)
    },
    body: function(newBody) {
      this.formattedBody = formatBody(newBody)
    }
  },
  components: {
    Table
  }
};
</script>


<style scoped>
.chart-container{
  display: inline-block;
  width: calc(50% - 42px);
  margin: 20px;
}

.chart-container.table {
  width: calc(100% - 40px);
}
</style>



// WEBPACK FOOTER //
// src/components/dataviews/DataTable.vue